import heroImage from "@/assets/hero-driving.webp";
import heroImageMobile from "@/assets/hero-driving-mobile.webp";

export const HeroSection = () => {
  return (
    <section className="relative min-h-[40vh] lg:h-[50vh] flex items-center bg-gradient-hero overflow-hidden pt-4 pb-6" style={{ WebkitTransform: 'translateZ(0)', willChange: 'auto' }}>
      {/* Background decoration - simplified for iOS Safari performance */}
      <div className="absolute inset-0 bg-black/20" />
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent/20 rounded-full opacity-50 hidden lg:block" />
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-glow/20 rounded-full opacity-50 hidden lg:block" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 items-center">
          {/* Content */}
          <div className="text-center lg:text-left space-y-4 lg:space-y-6">
            <div className="space-y-2 lg:space-y-3">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Vind jouw perfecte{" "}
                <span className="bg-gradient-to-r from-accent to-accent-glow bg-clip-text text-transparent">
                  theorie training
                </span>
              </h1>
              <p className="text-base lg:text-lg text-white/90 max-w-xl">
                Ontdek alle rijscholen, online trainingen, boeken en video's op één plek. 
                Vergelijk aanbieders en vind wat perfect bij jou past!
              </p>
            </div>

            {/* Quick Stats */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 text-white/90">
              <div className="text-center">
                <div className="text-xl lg:text-2xl font-bold text-accent">500+</div>
                <div className="text-xs lg:text-sm">Rijscholen</div>
              </div>
              <div className="text-center">
                <div className="text-xl lg:text-2xl font-bold text-accent">1000+</div>
                <div className="text-xs lg:text-sm">Online Cursussen</div>
              </div>
              <div className="text-center">
                <div className="text-xl lg:text-2xl font-bold text-accent">5000+</div>
                <div className="text-xs lg:text-sm">Reviews</div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative hidden lg:block">
            <div className="relative z-10">
              <img 
                src={heroImage} 
                srcSet={`${heroImageMobile} 400w, ${heroImage} 600w`}
                sizes="(max-width: 1024px) 400px, 600px"
                alt="Auto theorie training platform"
                className="w-full max-h-[35vh] object-cover rounded-2xl shadow-2xl"
                fetchPriority="high"
                loading="eager"
                width="600"
                height="350"
                decoding="async"
              />
            </div>
            {/* Floating elements */}
            <div className="absolute -top-3 -right-3 bg-accent text-accent-foreground p-3 rounded-xl shadow-lg z-20">
              <div className="text-base font-bold">98%</div>
              <div className="text-xs">Slaagkans</div>
            </div>
            <div className="absolute -bottom-3 -left-3 bg-success text-success-foreground p-3 rounded-xl shadow-lg z-20">
              <div className="text-base font-bold">5000+</div>
              <div className="text-xs">Leerlingen</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
